<div class="min-h-screen bg-zinc-100 flex items-center justify-center px-4 py-10">
  <div class="w-full max-w-md rounded-2xl bg-white shadow-xl border border-zinc-200 p-6 sm:p-8">
    <div class="mb-6">
      <h1 class="text-2xl font-semibold text-zinc-900">Forgot password</h1>
      <p class="mt-2 text-sm text-zinc-600">
        Enter your email address and we'll send you a password reset link.
      </p>
    </div>

    @if (!submitted()) {
      <form [formGroup]="form" (ngSubmit)="submit()" class="space-y-5">
        <div>
          <label for="email" class="block text-sm font-medium text-zinc-700 mb-1">
            Email
          </label>
          <input
            id="email"
            type="email"
            formControlName="email"
            class="w-full rounded-xl border border-zinc-300 bg-white px-4 py-3 text-zinc-900 outline-none focus:border-zinc-500"
            placeholder="name@example.com"
          />

          @if (form.controls.email.touched && form.controls.email.invalid) {
            <p class="mt-1 text-sm text-red-600">
              Please enter a valid email address.
            </p>
          }
        </div>

        @if (errorMessage()) {
          <div class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {{ errorMessage() }}
          </div>
        }

        <button
          type="submit"
          [disabled]="loading()"
          class="w-full rounded-xl bg-zinc-900 text-white py-3 font-medium disabled:opacity-60"
        >
          {{ loading() ? 'Sending link...' : 'Send reset link' }}
        </button>
      </form>
    } @else {
      <div class="rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-4 text-sm text-emerald-800">
        If an account exists for that email, a password reset link has been sent.
      </div>
    }

    <div class="mt-6 text-sm">
      <a routerLink="/login" class="text-zinc-700 hover:text-zinc-900 underline">
        Back to login
      </a>
    </div>
  </div>
</div>